import { IconsVariant } from "@/Components/Icon/Icon";
import { CountryCode, Sources } from "./enum";

export type Source = {
  label: string;
  value: number[];
  translationKey: string;
  icon?: IconsVariant;
  countries: number[];
  bg?: string;
  liveSourceValue?: number[];
  heatmapSourceValue?: { translationKey: string; value: number[] };
  financialSourceValue?: {
    translationKey: string;
    value: number[];
    key: string;
  };
};

export const sources: Source[] = [
  {
    label: "Website",
    value: [Sources.WEBSITE],
    translationKey: "website",
    icon: "desktop",
    countries: [CountryCode.ALL],
    liveSourceValue: [
      Sources.WEBSITE,
      Sources.IOS_V1_V2,
      Sources.IOS_V3,
      Sources.IOS_WEB_APP,
      Sources.IOS_NATIVE_APP,
      Sources.ANDROID_V2,
      Sources.ANDROID_WEB_APP,
      Sources.ANDROID_NATIVE_APP,
    ],
    heatmapSourceValue: { translationKey: "website", value: [Sources.WEBSITE] },
  },
  {
    label: "Thuisbezorgd",
    value: [Sources.THUISBEZORGD_NL],
    translationKey: "thuisbezorgd",
    icon: "thuisbezorgd",
    countries: [CountryCode.NETHERLANDS, CountryCode.BELGIUM],
    bg: "#FF8001",
    liveSourceValue: [Sources.THUISBEZORGD_NL],
    heatmapSourceValue: {
      translationKey: "thuisbezorgd",
      value: [Sources.THUISBEZORGD_NL],
    },
    financialSourceValue: {
      translationKey: "thuisbezorgd",
      value: [Sources.THUISBEZORGD_NL],
      key: "THUISBEZORGD_NL",
    },
  },
  {
    label: "UberEats",
    value: [Sources.UBER_EATS],
    translationKey: "uberEats",
    icon: "uberEats",
    countries: [CountryCode.ALL],
    bg: "#06C167",
    liveSourceValue: [Sources.UBER_EATS],
    heatmapSourceValue: {
      translationKey: "uberEats",
      value: [Sources.UBER_EATS],
    },
    financialSourceValue: {
      translationKey: "uberEats",
      value: [Sources.UBER_EATS],
      key: "UBER_EATS",
    },
  },
  {
    label: "homie",
    value: [Sources.HOMIE],
    translationKey: "homie",
    icon: "homie",
    countries: [CountryCode.NETHERLANDS],
    bg: "var(--homie)",
    liveSourceValue: [Sources.HOMIE],
    heatmapSourceValue: {
      translationKey: "homie",
      value: [Sources.HOMIE],
    },
  },
  {
    label: "IosWebApp",
    value: [
      Sources.IOS_V1_V2,
      Sources.IOS_V3,
      Sources.IOS_WEB_APP,
      Sources.IOS_NATIVE_APP,
    ],
    translationKey: "ioswebapp",
    icon: "apple",
    countries: [CountryCode.ALL],
    /* combined with android apps */
    heatmapSourceValue: {
      translationKey: "apps",
      value: [
        Sources.IOS_V1_V2,
        Sources.IOS_V3,
        Sources.IOS_WEB_APP,
        Sources.IOS_NATIVE_APP,
        Sources.ANDROID_V2,
        Sources.ANDROID_WEB_APP,
        Sources.ANDROID_NATIVE_APP,
      ],
    },
  },
  {
    label: "AndroidWebApp",
    value: [
      Sources.ANDROID_V2,
      Sources.ANDROID_WEB_APP,
      Sources.ANDROID_NATIVE_APP,
    ],
    translationKey: "androidwebapp",
    icon: "android",
    countries: [CountryCode.ALL],
  },
  {
    label: "Pos Order",
    value: [Sources.POS],
    translationKey: "posOrder",
    icon: "utensils",
    countries: [CountryCode.ALL],
    liveSourceValue: [Sources.POS],
    financialSourceValue: {
      translationKey: "pos",
      value: [Sources.POS],
      key: "POS",
    },
  },
  {
    label: "Qr",
    value: [Sources.QR],
    translationKey: "qrTableOrder",
    icon: "qr",
    countries: [CountryCode.ALL],
    liveSourceValue: [Sources.QR],
  },
  {
    label: "Kiosk",
    value: [Sources.KIOSK],
    translationKey: "kiosk",
    icon: "kiosk",
    countries: [CountryCode.ALL],
    liveSourceValue: [Sources.KIOSK],
  },
];

export const filterSourceByCountry = (country: number) => {
  return sources.filter(
    (p) =>
      p.countries?.includes(country) || p.countries?.includes(CountryCode.ALL)
  );
};
